import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import SearchBar from '../../components/common/SearchBar';
import StatusBadge from '../../components/common/StatusBadge';
import Modal from '../../components/common/Modal';
import toast from 'react-hot-toast';
import { formatDate } from '../../utils/helpers';
import TimePolicyMaster from './TimePolicyMaster';
import AbsentSmsSettings from './AbsentSmsSettings';

const ROLE_COLORS = {
  super_admin: 'bg-danger', admin: 'bg-primary', principal: 'bg-purple',
  teacher: 'bg-success', accountant: 'bg-warning text-dark', librarian: 'bg-info text-dark',
  parent: 'bg-secondary', student: 'bg-light text-dark',
};

const Administration = () => {
  const [tab, setTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [auditLogs, setAuditLogs] = useState([]);
  const [sysConfig, setSysConfig] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ username: '', email: '', first_name: '', last_name: '', role: '', password: '' });
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
const loadRoles = async () => {
    try {
        const res = await adminAPI.roles();

        const data = Array.isArray(res.data)
            ? res.data
            : res.data.results || [];

        setRoles(data);

    } catch (err) {
        console.error(err);
    }
};

  const loadPermissions = async () => {
    try {
        const res = await adminAPI.permissions();

        console.log("========== PERMISSION API ==========");
        console.log(res);
        console.log(res.data);
        console.log(Array.isArray(res.data));
        console.log("Length:", res.data.length);

        setPermissions(Array.isArray(res.data) ? res.data : res.data.results || []);

    } catch (err) {
        console.error(err);
    }
};
const handleDeleteUser = async (id) => {

    if (!window.confirm("Are you sure you want to delete this user?")) {
        return;
    }

    try {

        await adminAPI.deleteUser(id);

        toast.success("User deleted successfully");

        loadUsers();

    } catch (err) {
        console.error(err);
        toast.error("Failed to delete user");
    }
};
const updatePermission = async (id, field, value) => {
    try {
        await adminAPI.updatePermission(id, {
            [field]: value,
        });

        // Update local state
        setPermissions(prev =>
            prev.map(permission =>
                permission.id === id
                    ? { ...permission, [field]: value }
                    : permission
            )
        );

        toast.success("Permission updated");
    } catch (err) {
        console.error(err);
        toast.error("Failed to update permission");
    }
};
useEffect(() => {
	loadRoles();
    loadPermissions();
}, []);

  useEffect(() => { loadUsers(); }, [search]);
  const [editingUser, setEditingUser] = useState(null);
  const loadUsers = () => {
    setLoading(true);
    adminAPI.users({ search, page_size: 20 }).then(r => setUsers(r.data.results || r.data)).catch(() => { }).finally(() => setLoading(false));
  };
	const handleEdit = (user) => {
		setEditingUser(user);

		setForm({
			username: user.username || "",
			first_name: user.first_name || "",
			last_name: user.last_name || "",
			email: user.email || "",
			role: user.profile?.role?.name || "",
			password: "",
		});

		setShowModal(true);
	};
	const handleCreateUser = async (e) => {
    e.preventDefault();

    try {

        const payload = {
            username: form.username,
            first_name: form.first_name,
            last_name: form.last_name,
            email: form.email,
            role: form.role,
        };

        // Send password only if entered
        if (form.password && form.password.trim() !== "") {
            payload.password = form.password;
        }

        if (editingUser) {
            await adminAPI.updateUser(editingUser.id, payload);
            toast.success("User updated successfully");
        } else {
            await adminAPI.createUser(payload);
            toast.success("User created successfully");
        }

        setShowModal(false);
        setEditingUser(null);

        setForm({
            username: "",
            email: "",
            first_name: "",
            last_name: "",
            role: "",
            password: "",
        });

        loadUsers();

    } catch (err) {
        console.error(err);
        toast.error("Failed to save user");
    }
};
  const userColumns = [
    { key: 'username', label: 'Username', render: v => <strong>@{v}</strong> },
    { key: 'first_name', label: 'Full Name', render: (v, row) => `${v} ${row.last_name}`.trim() || '—' },
    { key: 'email', label: 'Email' },
    {
  key: "profile",
  label: "Role",
  render: (v) => {
    const roleName =
      typeof v?.role === "string"
        ? v.role
        : v?.role?.name || "";

    return roleName ? (
      <span className={`badge ${ROLE_COLORS[roleName] || "bg-secondary"}`}>
        {roleName.replace(/_/g, " ")}
      </span>
    ) : (
      "—"
    );
  },
},{
  key: "actions",
  label: "Actions",
  render: (_, row) => (
    <div className="d-flex gap-2">
      <button
        className="btn btn-sm btn-warning"
       onClick={() => handleEdit(row)}
      >
        ✏ Edit
      </button>

      <button
        className="btn btn-sm btn-danger"
        onClick={() => handleDeleteUser(row.id)}
      >
        🗑 Delete
      </button>
    </div>
  ),
},
    { key: 'is_active', label: 'Status', render: v => <StatusBadge status={v ? 'active' : 'inactive'} /> },
    { key: 'date_joined', label: 'Joined', render: v => formatDate(v) },
  ];

  const auditColumns = [
    { key: 'timestamp', label: 'Time', render: v => <small>{new Date(v).toLocaleString('en-IN')}</small> },
    { key: 'user_name', label: 'User', render: v => v || 'System' },
    { key: 'action', label: 'Action', render: v => <span className={`badge ${v === 'delete' ? 'bg-danger' : v === 'create' ? 'bg-success' : 'bg-info text-dark'}`}>{v}</span> },
    { key: 'model_name', label: 'Module' },
    { key: 'description', label: 'Description', render: v => <small>{v}</small> },
    { key: 'ip_address', label: 'IP', render: v => v ? <code style={{ fontSize: 11 }}>{v}</code> : '—' },
  ];

  const configItems = [
    { key: 'school_name', label: '🏫 School Name', desc: 'Official school name' },
    { key: 'academic_year', label: '📅 Current Academic Year', desc: 'Active academic year' },
    { key: 'address', label: '📍 School Address', desc: 'Full school address' },
    { key: 'phone', label: '📞 School Phone', desc: 'Contact number' },
    { key: 'email', label: '📧 School Email', desc: 'Official email' },
    { key: 'principal', label: '👨‍💼 Principal Name', desc: 'Current principal' },
  ];

  const handleAccessChange = (module, index, checked) => {
    setPermissions(prev => ({
      ...prev,
      [module]: prev[module].map((access, i) =>
        i === index ? checked : access
      ),
    }));
  };
const groupedPermissions = permissions.reduce((acc, permission) => {
    if (!acc[permission.module]) {
        acc[permission.module] = {};
    }

    acc[permission.module][permission.role_name] = permission;

    return acc;
}, {}); return (
    <div>
      {/* <div className="page-header mt-0">
        <div><h2>Administration</h2><p>User management, system config, and audit logs</p></div>
        {tab === 'users' && <button className="btn btn-primary" onClick={() => setShowModal(true)}>➕ Create User</button>}
      </div> */}

      <div className="d-flex justify-content-between mb-4 flex-wrap">
        <span className='d-flex gap-2'>
          {[['users', '👥 Users'], ['roles', '🔐 Roles & Permissions'], [' TimePolicy', '⚙️  Time Policy Master'], , [' AbsentSmsSettings', '⚙️  Absent Sms Settings'],].map(([k, l]) => (
            <button key={k} className={`btn ${tab === k ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(k)}>{l}</button>
          ))}
        </span>
        {/*  ['config', '⚙️ System Config'],  ['audit', '📋 Audit Logs'], ['backup', '💾 Backup & Security']*/}

        {tab === 'users' && <button className="btn btn-primary ms-4" onClick={() => setShowModal(true)}>➕ Create User</button>}
      </div>

      {tab === 'users' && (
        <div>
          <div className="card mb-3"><div className="card-body">
            <SearchBar onSearch={setSearch} placeholder="Search users by name, username, email..." />


          </div>
          </div>
          <div className="card">
            <div className="card-header"><span>👥 System Users ({users.length})</span></div>
            <DataTable columns={userColumns} data={users} loading={loading} />
          </div>


        </div>
      )}

      {tab === 'roles' && (
        <div className="card"><div className="card-body">
          <h6 className="mb-4 fw-bold">🔐 Role Permissions Matrix</h6>
          <div className="table-responsive">
            <table className="table table-bordered w-100" style={{ fontSize: 12 }}>
              <thead>
                <tr>
                  <th>Module</th>
					 {roles.map((role) => (
						<th key={role.id}>
							{role.name.replace("_", " ").toUpperCase()}
						</th>
				))}
                </tr>
              </thead>
		<tbody>
			{Object.entries(groupedPermissions).map(([module, modulePermissions]) => (
				<tr key={module}>
					<td>{module}</td>

					{roles.map((role) => {
						const permission = modulePermissions[role.name];

						return (
							<td key={role.id}>
								{permission ? (
									<div className="d-flex gap-2 flex-wrap">

										<label title="View">
											<input
												type="checkbox"
												checked={permission.can_view}
												onChange={(e) =>
													updatePermission(
														permission.id,
														"can_view",
														e.target.checked
													)
												}
											/>
											
										</label>

							</div>
								) : (
									"-"
								)}
							</td>
						);
					})}
				</tr>
			))}
		</tbody>

            </table>
          </div>
        </div></div>
      )}

      {tab === 'config' && (
        <div className="card"><div className="card-header"><span>⚙️ System Configuration</span></div><div className="card-body">
          <div className="row g-3">
            {configItems.map(item => {
              const cfg = sysConfig.find(c => c.key === item.key);
              return (
                <div key={item.key} className="col-md-6">
                  <div style={{ background: '#f8fafc', borderRadius: 10, padding: 16 }}>
                    <label className="form-label fw-bold" style={{ fontSize: 13 }}>{item.label}</label>
                    <small className="d-block text-muted mb-2">{item.desc}</small>
                    <div className="d-flex gap-2">
                      <input className="form-control form-control-sm" defaultValue={cfg?.value || ''} />
                      <button className="btn btn-sm btn-primary">💾</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div></div>
      )}

      {tab === ' TimePolicy' && (
        <TimePolicyMaster />
        // <div className="card">

        //   <div className="card-body"><span>📋  Time Policy</span></div>
        //   <DataTable columns={auditColumns} data={auditLogs} loading={false} />
        // </div>
      )}
      {tab === ' AbsentSmsSettings' && (
        <AbsentSmsSettings />

      )}

      {tab === 'audit' && (
        <div className="card">
          <div className="card-header"><span>📋 Audit Logs</span></div>
          <DataTable columns={auditColumns} data={auditLogs} loading={false} />
        </div>
      )}

      {tab === 'backup' && (
        <div className="row g-3">
          {[
            { icon: '💾', title: 'Database Backup', desc: 'Create a full backup of the database', btn: 'Create Backup', color: '#eff6ff' },
            { icon: '🔄', title: 'Restore Data', desc: 'Restore from a previous backup file', btn: 'Choose File', color: '#f0fdf4' },
            { icon: '🔒', title: 'Security Settings', desc: 'Configure password policies and 2FA', btn: 'Configure', color: '#faf5ff' },
            { icon: '🔑', title: 'API Keys', desc: 'Manage API access tokens', btn: 'Manage Keys', color: '#fff7ed' },
          ].map(item => (
            <div key={item.title} className="col-md-6">
              <div style={{ background: item.color, borderRadius: 14, padding: 24 }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{item.icon}</div>
                <h6 style={{ fontWeight: 700 }}>{item.title}</h6>
                <p style={{ fontSize: 13, color: '#64748b' }}>{item.desc}</p>
                <button className="btn btn-primary btn-sm">{item.btn}</button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal show={showModal} onClose={() => setShowModal(false)} title={editingUser ? "Edit User" : "Create New User"}>
        <form onSubmit={handleCreateUser}>
          <div className="row">
            <div className="col-md-6 mb-3"><label className="form-label">First Name</label><input className="form-control" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} /></div>
            <div className="col-md-6 mb-3"><label className="form-label">Last Name</label><input className="form-control" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} /></div>
            <div className="col-md-6 mb-3"><label className="form-label">Username *</label><input className="form-control" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required /></div>
            <div className="col-md-6 mb-3"><label className="form-label">Email *</label><input type="email" className="form-control" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required /></div>
            <div className="col-md-6 mb-3"><label className="form-label">Role</label>
				<select
					className="form-select"
					value={form.role}
					onChange={(e) => setForm({ ...form, role: e.target.value })}
				>
					<option value="">Select Role</option>

					{roles.map((role) => (
						<option key={role.id} value={role.name}>
							{role.name.replace(/_/g, " ")}
						</option>
					))}
				</select>
            </div>
            <div className="col-md-6 mb-3"><label className="form-label">Password *</label>
					<input
			type="password"
			className="form-control"
			value={form.password}
			onChange={e => setForm({ ...form, password: e.target.value })}
			placeholder={editingUser ? "Leave blank to keep current password" : ""}
			required={!editingUser}
		/> </div>
          </div>
          <div className="d-flex gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowModal(false)}>Cancel</button>
            <button type="submit" className="btn btn-primary">➕ Create User</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Administration;
